(function () {
  'use strict';
  var routes = window.theme && window.theme.routes ? window.theme.routes : { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  var strings = (window.theme && window.theme.strings) || {};

  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = d.querySelector('button, a, input'); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      if (opener.getAttribute('data-open-drawer') === 'CartDrawer' && !document.getElementById('CartDrawer')) return;
      e.preventDefault(); openDrawer(opener.getAttribute('data-open-drawer'));
      if (opener.getAttribute('data-open-drawer') === 'CartDrawer') refreshCart();
      return;
    }
    var closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var o = document.querySelector('.drawer.is-open'); if (o) closeDrawer(o); }
  });

  /* ---------- Cart ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    var list = document.querySelector('[data-mini-cart-items]');
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<li style="border:0;justify-content:center;padding:40px 0">' + esc(strings.cartEmpty || 'Your cart is empty') + '</li>';
    } else {
      list.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') + '" alt="" width="70" height="86" loading="lazy">' : '<span style="width:70px;height:86px;background:var(--c-bg-alt)"></span>';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
        return '<li>' + img + '<div class="mini-cart__meta"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<small>' + it.quantity + ' × ' + money(it.final_price) + '</small>' +
          '<button class="link-btn" type="button" data-remove="' + esc(it.key) + '">' + esc(strings.remove || 'Remove') + '</button></div>' +
          '<div>' + money(it.final_line_price) + '</div></li>';
      }).join('');
    }
    var total = document.querySelector('[data-mini-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    var fs = document.querySelector('[data-free-ship]');
    if (fs) {
      var goal = parseInt(fs.getAttribute('data-free-ship'), 10) || 0;
      var left = goal - cart.total_price;
      var msg = fs.querySelector('span'), bar = fs.querySelector('i');
      if (msg) msg.textContent = left > 0 ? (strings.freeShipAway || 'You are [amount] away from free delivery').replace('[amount]', money(left)) : (strings.freeShipDone || 'You have unlocked free delivery!');
      if (bar) bar.style.width = Math.min(100, goal ? (cart.total_price / goal) * 100 : 100) + '%';
    }
  }
  function refreshCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (!rm) return;
    e.preventDefault();
    fetch(routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: rm.getAttribute('data-remove'), quantity: 0 }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]') || !document.getElementById('CartDrawer')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-form-error]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    if (err) { err.hidden = true; err.textContent = ''; }
    fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { if (err) { err.textContent = res.body.description || res.body.message || 'Error'; err.hidden = false; } return; }
        return refreshCart().then(function () { openDrawer('CartDrawer'); });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  /* ---------- Product: variants, gallery, qty ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    var product; try { product = JSON.parse(json.textContent); } catch (e) { return; }
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var btn = root.querySelector('[data-add-btn]');
    var mainImg = root.querySelector('.js-main-image');

    function current() {
      var chosen = [];
      root.querySelectorAll('.option').forEach(function (fs) {
        var c = fs.querySelector('input:checked'); if (c) chosen.push(c.value);
      });
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
    }
    function update() {
      var v = current();
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = strings.unavailable || 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s><ins>' + money(v.price) + '</ins>' : money(v.price);
      if (priceEl) priceEl.classList.toggle('price--sale', v.compare_at_price > v.price);
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out'); }
      if (v.featured_image && mainImg) setMain(v.featured_image.src, v.featured_image.alt);
      if (window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
    }
    function setMain(src, alt) {
      if (!mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
      if (alt) mainImg.alt = alt;
    }
    root.addEventListener('change', function (e) { if (e.target.closest('.option')) update(); });
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        setMain(t.getAttribute('data-thumb'), t.getAttribute('data-alt'));
      });
    });
  });
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]');
    if (!q) return;
    var input = q.parentElement.querySelector('input');
    var val = (parseInt(input.value, 10) || 1) + (q.getAttribute('data-qty') === 'up' ? 1 : -1);
    input.value = Math.max(parseInt(input.min || '1', 10), val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) { el.hidden = true; return; }
    var parts = el.querySelectorAll('b');
    function tick() {
      var d = Math.max(0, end - Date.now());
      var vals = [Math.floor(d / 864e5), Math.floor(d / 36e5) % 24, Math.floor(d / 6e4) % 60, Math.floor(d / 1e3) % 60];
      parts.forEach(function (p, i) { p.textContent = String(vals[i]).padStart(2, '0'); });
      if (d > 0) setTimeout(tick, 1000);
    }
    tick();
  });

  /* ---------- Collection sort ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
  });
  document.querySelectorAll('[data-filter-form]').forEach(function (f) {
    f.addEventListener('change', function () { f.requestSubmit ? f.requestSubmit() : f.submit(); });
  });

  /* ---------- Reveal on scroll ---------- */
  var items = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (i) { io.observe(i); });
  } else { items.forEach(function (i) { i.classList.add('is-in'); }); }
  if (window.Shopify && window.Shopify.designMode) items.forEach(function (i) { i.classList.add('is-in'); });
})();
